// @flow

import Rehype from 'rehype-react';
import * as React from 'react';

// $FlowFixMe unist not supported on Flow Typed
export const buildSections = elements => {
  // sections that should initialize a new page
  const sectionTags = ['h1', 'h2', 'h3', 'h4', 'hr', 'br'];
  const sections = [];
  return elements
    .filter(node => node.type === 'element')
    .reduce((acc, cur) => {
      if (!acc.length || sectionTags.includes(cur.tagName)) {
        acc.push({
          tagName: 'section',
          type: 'element',
          properties: {},
          children: [cur],
        });
      } else {
        acc[acc.length - 1].children.push(cur);
      }
      return acc;
    }, sections);
};

export const astToHtml = new Rehype({
  createElement: React.createElement,
  Fragment: React.Fragment,
}).Compiler;

export const shortModes = {
  a: 'article',
  p: 'presentation',
  s: 'speaker',
  n: 'notes',
};

export const shortModeMap = {
  article: 'a',
  presentation: 'p',
  speaker: 's',
  notes: 'n',
};

export const parseShortMode = (m: $Values<typeof shortModeMap>) =>
  shortModes.hasOwnProperty(m) ? shortModes[m] : shortModes.a;

export const getShortMode = (mode: $Values<typeof shortModes>) =>
  shortModeMap[mode];

export const modes = {
  article: 'article',
  presentation: 'presentation',
  speaker: 'speaker',
  notes: 'notes',
};

// $FlowIgnoreNextLine vendor
export const debounce = (func, wait, immediate) => {
  var timeout;

  return function executedFunction() {
    var context = this;
    var args = arguments;

    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
};
